import { CustomAdUnitConfig } from '@/types'

const COMMON_CAMPAIGN_ID = 'playgama-anti-fraud-brand'

export const ANTI_FRAUD_BANNERS_CONFIG: CustomAdUnitConfig[] = [
    {
        platforms: ['desktop'],
        campaignId: COMMON_CAMPAIGN_ID,
        creatives: [
            {
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'c82ca5d9-38ef-432b-25f1-2b183ab84b00',
                width: 540,
                height: 300,
            },
        ],
    },
    {
        platforms: ['ios', 'android'],
        campaignId: COMMON_CAMPAIGN_ID,
        creatives: [
            {
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'c809302d-1ba1-462f-c66f-1b54a4e55b00',
                supportedOrientations: ['portrait'],
                width: 300,
                height: 300,
            },
            {
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: '33525da5-dcab-43ae-a0e0-5b1471498000',
                supportedOrientations: ['landscape'],
                width: 320,
                height: 100,
            },
        ],
    },
]
